export const canonicalComputer = (item, pagination) => {
  const linkArr = []
  // Get the current page number and last page number from pagination
  const { currentPage, lastPage } = pagination

  const canonicalUrl = new URL(item.href)
  if(currentPage > 1) {
    // If page is greater than 1 add the page number to canonical link
    // If it is first page don't add page number to link
    canonicalUrl.searchParams.set('page', currentPage)

    // If page is greater than 2 set the prev link to 1 page lower
    // If page is equal to 2 don't set any page to prev link
    const prevUrl = new URL(item.href)
    if(currentPage > 2) prevUrl.searchParams.set('page', currentPage - 1)
    linkArr.push({
      href: prevUrl.href,
      rel: 'prev',
      tag: 'link',
    })
  }

  linkArr.push({
    href: canonicalUrl.href,
    rel: 'canonical',
    tag: 'link',
  })


  // If not last page add next link
  if(lastPage > currentPage) {
    const nextUrl = new URL(item.href)
    nextUrl.searchParams.set('page', currentPage + 1)
    linkArr.push({
      href: nextUrl.href,
      rel: 'next',
      tag: 'link',
    })
  }

  return linkArr
}
